import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=748c8fca&scoped=true&"
import script from "./nav.vue?vue&type=script&lang=js&"
export * from "./nav.vue?vue&type=script&lang=js&"
import style0 from "./nav.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./nav.vue?vue&type=style&index=1&id=748c8fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c8fca",
  null
  
)

export default component.exports